// Day colors map
const dayColors = {
  0:{day:"Ravivaar",planet:"Surya · Sun",colour:"#E85A00",name:"Saffron"},
  1:{day:"Somvaar",planet:"Chandra · Moon",colour:"#D0D0C0",name:"White"},
  2:{day:"Mangalvaar",planet:"Mangal · Mars",colour:"#C01828",name:"Sindoor Red"},
  3:{day:"Budhvaar",planet:"Budh · Mercury",colour:"#18A840",name:"Forest Green"},
  4:{day:"Guruvaar",planet:"Guru · Jupiter",colour:"#E8C010",name:"Pitambari Yellow"},
  5:{day:"Shukravaar",planet:"Shukra · Venus",colour:"#D42060",name:"Lotus Magenta"},
  6:{day:"Shanivaar",planet:"Shani · Saturn",colour:"#1A1860",name:"Indigo"}
};

function initDay() {
  const d = new Date().getDay();
  const dc = dayColors[d];

  const dot = document.getElementById('dayDot');
  const label = document.getElementById('dayLabel');
  if (dot) dot.style.background = dc.colour;
  if (label) label.textContent = dc.day;

  const todayDay = document.getElementById('todayDay');
  const todayPlanet = document.getElementById('todayPlanet');
  const todaySwatch = document.getElementById('todaySwatch');
  const todayColour = document.getElementById('todayColour');
  if (todayDay) todayDay.textContent = dc.day;
  if (todayPlanet) todayPlanet.textContent = dc.planet;
  if (todaySwatch) todaySwatch.style.background = dc.colour;
  if (todayColour) todayColour.textContent = dc.name;
}

// Nav scroll — only reactive on the home page; other pages start scrolled
if (document.body.classList.contains('template-index')) {
  window.addEventListener('scroll', () => {
    const nav = document.getElementById('nav');
    if (window.scrollY > 80) nav.classList.add('scrolled');
    else nav.classList.remove('scrolled');
  });
}

// ── Mobile nav ──
// The desktop nav links are hidden under 900px; without this the main nav is
// unreachable on a phone.
function toggleNavMenu() {
  const menu = document.getElementById('navMobile');
  const burger = document.getElementById('navBurger');
  if (!menu || !burger) return;
  const open = menu.classList.toggle('open');
  burger.classList.toggle('open', open);
  burger.setAttribute('aria-expanded', String(open));
}

// ── Shopify Cart API ──

async function fetchCart() {
  const res = await fetch('/cart.js');
  return res.json();
}

async function addToCart(variantId, quantity = 1) {
  const res = await fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: variantId, quantity })
  });
  if (!res.ok) {
    showNotif('Could not add to bag — out of stock');
    return;
  }
  const data = await res.json();
  await renderCart();
  showNotif(data.product_title.split(' ').slice(0, 3).join(' ') + ' added to bag');
}

async function removeFromCart(key) {
  await fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: key, quantity: 0 })
  });
  await renderCart();
}

async function changeQty(key, delta) {
  const cart = await fetchCart();
  const item = cart.items.find(i => i.key === key);
  if (!item) return;
  const newQty = item.quantity + delta;
  await fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: key, quantity: newQty })
  });
  await renderCart();
}

// Storefront config injected by layout/theme.liquid — market-aware.
const VCFG = window.VAASYA || {
  countryCode: 'IN', currency: 'INR', isIndia: true,
  freeShippingThreshold: 99900, flatShippingRate: 9900
};

// Money formatting follows the active market's currency, not a hardcoded ₹.
// INR uses en-IN grouping (₹3,500) — never the European ₹3.500.
function fmt(minorUnits, currency) {
  const cur = currency || VCFG.currency || 'INR';
  const locale = cur === 'INR' ? 'en-IN' : undefined;
  try {
    return new Intl.NumberFormat(locale, {
      style: 'currency',
      currency: cur,
      minimumFractionDigits: cur === 'INR' ? 0 : 2,
      maximumFractionDigits: cur === 'INR' ? 0 : 2
    }).format(minorUnits / 100);
  } catch (e) {
    return '₹' + (minorUnits / 100).toLocaleString('en-IN', { maximumFractionDigits: 0 });
  }
}

// Brand vocabulary guard for variant titles coming back from the Cart API.
function safeVariantTitle(title) {
  if (!title) return '';
  return title
    .replace(/Idol/g, 'Murti').replace(/idol/g, 'murti')
    .replace(/Dress/g, 'Poshaak').replace(/dress/g, 'poshaak');
}

function escapeHtml(str) {
  return String(str == null ? '' : str).replace(/[&<>"']/g, c => ({
    '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'
  }[c]));
}

async function renderCart() {
  const cart = await fetchCart();
  const currency = cart.currency || VCFG.currency;
  const ci = document.getElementById('cartItems');
  const cf = document.getElementById('cartFoot');
  const bagCt = document.getElementById('bagCt');

  if (bagCt) {
    bagCt.textContent = cart.item_count;
    bagCt.classList.add('pop');
    setTimeout(() => bagCt.classList.remove('pop'), 300);
  }

  if (!ci) return;

  if (!cart.items.length) {
    ci.innerHTML = `<div class="cart-empty-state">
      <div class="empty-icon">🪔</div>
      <h3>Your bag is empty</h3>
      <p>The collection awaits.<br/>Every piece has a reason.</p>
      <a class="btn btn-dark" href="/collections/all" onclick="closeCart()">Shop the Collection</a>
    </div>`;
    if (cf) cf.innerHTML = '';
    return;
  }

  ci.innerHTML = cart.items.map(item => {
    const variant = item.variant_title && item.variant_title !== 'Default Title'
      ? escapeHtml(safeVariantTitle(item.variant_title)) : '';
    return `
    <div class="cart-item">
      <div class="ci-img">
        ${item.image
          ? `<img src="${escapeHtml(item.image)}" alt="${escapeHtml(item.product_title)}" loading="lazy">`
          : `<div class="disc disc-copper" style="width:48px;height:48px;"><div class="disc-mid"></div><div class="disc-dot"></div></div>`
        }
      </div>
      <div class="ci-details">
        <div class="ci-name">${escapeHtml(item.product_title)}</div>
        <div class="ci-var">${variant}</div>
        <div class="ci-price">${fmt(item.final_line_price, currency)}</div>
        <div class="ci-qty">
          <button class="qty-b" onclick="changeQty('${item.key}', -1)">−</button>
          <span style="font-size:14px;min-width:20px;text-align:center;">${item.quantity}</span>
          <button class="qty-b" onclick="changeQty('${item.key}', 1)">+</button>
          <button class="ci-remove" onclick="removeFromCart('${item.key}')">Remove</button>
        </div>
      </div>
    </div>`;
  }).join('');

  const subtotal = cart.total_price;
  const threshold = VCFG.freeShippingThreshold;

  // India: flat rate with a free-shipping threshold and a progress nudge.
  // Everywhere else: shipping is carrier-calculated on actuals, so we promise
  // nothing here and let checkout quote the real number.
  let shipRow, progressBlock, footNote, total;

  if (threshold) {
    const qualifies = subtotal >= threshold;
    const ship = qualifies ? 0 : (VCFG.flatShippingRate || 0);
    const remaining = Math.max(0, threshold - subtotal);
    const pct = Math.min(100, Math.round((subtotal / threshold) * 100));

    shipRow = `<div class="cart-sub-row muted"><span>Shipping</span><span>${ship === 0 ? 'Free' : fmt(ship, currency)}</span></div>`;
    progressBlock = `
      <div class="ship-progress">
        <p class="ship-progress-text">${qualifies
          ? "You've unlocked free shipping ✦"
          : `You're ${fmt(remaining, currency)} away from free shipping`}</p>
        <div class="ship-progress-track"><div class="ship-progress-bar" style="width:${pct}%;"></div></div>
      </div>`;
    footNote = `<p class="cart-foot-note">Free shipping on orders above ${fmt(threshold, currency)}</p>`;
    total = subtotal + ship;
  } else {
    shipRow = `<div class="cart-sub-row muted"><span>Shipping</span><span>Calculated at checkout</span></div>`;
    progressBlock = '';
    footNote = `<p class="cart-foot-note">International shipping is calculated on actuals at checkout.</p>`;
    total = subtotal;
  }

  if (cf) cf.innerHTML = `
    <div class="cart-foot">
      ${progressBlock}
      <div class="cart-sub-row"><span style="color:var(--t2);">Subtotal</span><span>${fmt(subtotal, currency)}</span></div>
      ${shipRow}
      <div class="cart-total"><span>${threshold ? 'Total' : 'Subtotal'}</span><span>${fmt(total, currency)}</span></div>
      <a class="checkout-btn-full" href="/checkout">Proceed to Checkout</a>
      ${footNote}
    </div>`;
}

function openCart() {
  renderCart();
  document.getElementById('cartPanel').classList.add('open');
  document.getElementById('cartOv').classList.add('open');
}

function closeCart() {
  document.getElementById('cartPanel').classList.remove('open');
  document.getElementById('cartOv').classList.remove('open');
}

// ── Notification ──
function showNotif(msg) {
  const el = document.getElementById('notif');
  if (!el) return;
  el.textContent = msg;
  el.classList.add('show');
  setTimeout(() => el.classList.remove('show'), 2800);
}

// ── Scroll Reveal ──
let revObs;
function initReveal() {
  if (revObs) revObs.disconnect();
  revObs = new IntersectionObserver(entries => {
    entries.forEach(e => { if (e.isIntersecting) e.target.classList.add('on'); });
  }, { threshold: 0.12 });
  document.querySelectorAll('.reveal').forEach(el => revObs.observe(el));
}

// ── Init ──
initDay();
initReveal();

// Sync bag count on load
fetchCart().then(cart => {
  const bagCt = document.getElementById('bagCt');
  if (bagCt) bagCt.textContent = cart.item_count;
});
